import { render, staticRenderFns } from "./Portefeuille.vue?vue&type=template&id=42e1b428&scoped=true&"
import script from "./Portefeuille.vue?vue&type=script&lang=js&"
export * from "./Portefeuille.vue?vue&type=script&lang=js&"
import style0 from "./Portefeuille.vue?vue&type=style&index=0&id=42e1b428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e1b428",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e1b428')) {
      api.createRecord('42e1b428', component.options)
    } else {
      api.reload('42e1b428', component.options)
    }
    module.hot.accept("./Portefeuille.vue?vue&type=template&id=42e1b428&scoped=true&", function () {
      api.rerender('42e1b428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Portefeuille.vue"
export default component.exports